import React from "react";
import styled, { css } from "styled-components";

type SeparatorSize = "xsmall" | "small" | "medium" | "large" | "xlarge";

interface SeparatorProps {
  type: SeparatorSize;
}

const Separator = ({ type }: SeparatorProps) => {
  return <Container type={type} />;
};

const Container = styled.div<{
  type: SeparatorSize;
}>`
  ${(props) => {
    const type = props.type;
    let styles = css``;
    switch (type) {
      case "xsmall":
        styles = css`
          margin-bottom: ${4}px;
        `;
        break;
      case "small":
        styles = css`
          margin-bottom: ${4 * 2}px;
        `;
        break;
      case "medium":
        styles = css`
          margin-bottom: ${4 * 6}px;
        `;
        break;
      case "large":
        styles = css`
          margin-bottom: ${4 * 8}px;
        `;
        break;
      case "xlarge":
        styles = css`
          margin-bottom: ${4 * 10}px;
        `;
        break;
    }
    return styles;
  }}
`;

export default Separator;
